var _defs, _linearGradient, _linearGradient2, _linearGradient3, _radialGradient, _radialGradient2, _radialGradient3, _clipPath, _clipPath2, _clipPath3, _clipPath4, _g, _path, _path2, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromeBeta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 9390 9390",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    fill: "url(#a)",
    d: "M350 9050h4141l1922-1922V5689H2988L350 1165z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    fill: "url(#b)",
    d: "M1041 350v5339h1947l1712-2966h4350V350z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    fill: "url(#c)",
    d: "M4700 2723l1713 2966-1922 3361h4559V2723z"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1400,
    x2: 4000,
    y1: 3675,
    y2: 2150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a52714",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 5425,
    x2: 2550,
    y1: 8075,
    y2: 6400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#055524",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 5975,
    x2: 6700,
    y1: 2425,
    y2: 5600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ea6100",
    stopOpacity: 0
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 771,
    cy: -34,
    r: 166,
    gradientTransform: "matrix(25 0 0 -25 -14775 1875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2723",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 632,
    cy: -19,
    r: 154,
    xlinkHref: "#d"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 779,
    cy: -113,
    r: 174,
    gradientTransform: "matrix(25 0 0 -25 -14775 1875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4700,
    cy: 4700,
    r: 4350
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1041 350v1994l1947 3345 1712-2966h4350V350z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#db4437",
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e2723",
    fillOpacity: 0.1,
    d: "M3035 5671L1066 2295l-29 49 1955 3352z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0f9d58",
    xlinkHref: "#N"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    d: "M6373 5754l-41-23-1898 3319h57l1883-3294z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#ffcd40",
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#ffcd40",
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#db4437",
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M4700 2723v1035l3875-1035z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#0f9d58",
    xlinkHref: "#N"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M1041 2350l2829 2829-882 510z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M4494 9045l1036-3866 883 510z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4700,
    cy: 4700,
    r: 1977,
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4700,
    cy: 4700,
    r: 1582,
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e2723"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M4700 2673a1977 1977 0 00-1977 1978v49a1977 1977 0 011977-1977h4350v-49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M6410 5689a1974 1974 0 01-3421 0L350 1165v49l2638 4524a1974 1974 0 003421 0v-49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4749 2723h-25a1976 1976 0 010 3952h25a1977 1977 0 000-3955z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M6430 5754a1971 1971 0 00170-1584 1955 1955 0 01-191 1517L4491 9050h57l1883-3294zM4700 400a4350 4350 0 014350 4325v-25a4350 4350 0 10-8700 0v25A4350 4350 0 014700 400z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    d: "M4700 9000a4350 4350 0 004350-4325v25a4350 4350 0 11-8700 0v-25a4350 4350 0 004350 4325z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M204 5422h9118v3817H204z",
    clipPath: "url(#e)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3152 7500V6300h433a352 352 0 01243 93 300 300 0 01100 233 262 262 0 01-44 151 281 281 0 01-118 100v7a300 300 0 01146 100 271 271 0 0157 171 315 315 0 01-105 245 369 369 0 01-255 100zm154-684h279a180 180 0 00140-58 179 179 0 000-252 172 172 0 00-135-57h-284zm0 537h309a184 184 0 00144-62 200 200 0 0055-135 200 200 0 00-206-200h-300zm1184 170a400 400 0 01-300-124 439 439 0 01-116-313 451 451 0 01113-308 366 366 0 01288-129 379 379 0 01292 119 451 451 0 01109 318v29h-650a279 279 0 0083 200 251 251 0 00178 72 221 221 0 00224-141l137 57a369 369 0 01-132 160 384 384 0 01-226 60zm221-535a219 219 0 00-64-134 230 230 0 00-176-64 220 220 0 00-148 54 274 274 0 00-86 144zm634 521a238 238 0 01-264-263v-430h-144v-140h143v-251h154v251h200v141h-200v418q0 134 110 134a163 163 0 0070-13l54 132a311 311 0 01-123 21zm480 14a324 324 0 01-218-75 249 249 0 01-88-200 246 246 0 01100-210 420 420 0 01256-76 441 441 0 01223 50v-23a183 183 0 00-62-145 222 222 0 00-152-54 235 235 0 00-121 32 164 164 0 00-75 87l-141-60a319 319 0 01112-136 359 359 0 01221-63 379 379 0 01261 92 328 328 0 01100 259v500h-141v-119h-7a300 300 0 01-268 141zm25-141a251 251 0 00173-71 220 220 0 0077-168 300 300 0 00-200-54 254 254 0 00-169 49 146 146 0 00-57 114 110 110 0 0052 100 207 207 0 00124 30z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "M350 9050h4141l1922-1922V5689H2988L350 1165z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M4700 2723l1713 2966-1922 3361h4559V2723z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    d: "M1041 350v5339h1947l1712-2966h4350V350z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeBeta);
export default __webpack_public_path__ + "static/media/chrome-beta.05fbd6d9a2860a9f8c490de1b9ce5497.svg";
export { ForwardRef as ReactComponent };